import React from 'react';

function StocksSvg() {
	return (
		<svg
			width="80pt"
			height="80pt"
			viewBox="0 0 20 20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="0" fill="none" width="30" height="30" />

			<g>
				<path d="M18 18V2H2v16h16zM16 5H4V4h12v1zM7 7v3h3c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3zm1 2V7c1.1 0 2 .9 2 2H8zm8-1h-4V7h4v1zm0 3h-4V9h4v2zm0 2h-4v-1h4v1zm0 3H4v-1h12v1z" />
			</g>
		</svg>
	);
}

export default StocksSvg;
